import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingScreen from 'components/LoadingScreen';
import { personalDataStore } from 'stores/personalDataStore';
import { authUtils } from 'utils/auth';
import { PATHS } from 'routes/paths';

/**
 * Страница-приёмник токенов серверного OAuth-флоу (Яндекс).
 *
 * После колбэка бэкенд редиректит сюда (путь из OAUTH_SUCCESS_REDIRECT_URL)
 * с токенами в query: /auth/success?access_token=...&refresh_token=...
 *
 * Задача страницы — прочитать токены, убрать их из URL, поднять сессию тем же
 * способом, что и обычный email/phone-логин (personalDataStore.login), и увести
 * пользователя в приложение. userId в редиректе не приходит — достаём его из JWT.
 */
export default function AuthSuccessPage() {
  const navigate = useNavigate();
  // Защита от повторного запуска эффекта (StrictMode/ре-рендеры)
  const handledRef = useRef(false);

  useEffect(() => {
    if (handledRef.current) return;
    handledRef.current = true;

    const params = new URLSearchParams(window.location.search);
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');

    console.log(accessToken, refreshToken)

    // Убираем токены из URL (история браузера / Referer) до любых навигаций.
    window.history.replaceState({}, '', '/auth/success');

    if (!accessToken || !refreshToken) {
      return;
    }

    const userId = authUtils.getUserIdFromAccessToken(accessToken || '');
    if (!userId) {
      authUtils.clearAuth();
      return;
    }

    // Дальше — как с обычным логином: сохраняем токены, грузим пользователя,
    // уводим на профиль (если не заполнен) либо на главную.
    personalDataStore
      .login(accessToken, refreshToken, userId, (user) => {
        window.ym(108450737,'reachGoal','registration')
        navigate(!user.firstName ? `${PATHS.profile}?force=true` : PATHS.main, { replace: true });
      })
      .catch(() => {
        authUtils.clearAuth();
      });
  }, [navigate]);

  return <LoadingScreen label="Завершаем вход…" />;
}
